import "./GlobalMapIllustration.css";
import { CiStar, CiShare2, CiUser, CiDatabase } from "react-icons/ci";

const GlobalMapIllustration = () => {
  return (
    <div className="global-map-illustration">
      {/* World Map Background */}
      <div className="map-container">
        <img 
          src="/global-map.png" 
          alt="World Map" 
          className="world-map-image"
          onError={(e) => {
            // Fallback to SVG if image doesn't load
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
        
        {/* Fallback SVG Map */}
        <svg
          viewBox="0 0 800 400"
          className="world-map-svg"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Simplified world map paths */}
          <path
            className="map-path"
            d="M150,150 Q200,120 250,150 Q300,180 350,150 Q400,120 450,140 Q500,160 550,150 L550,200 Q500,190 450,200 Q400,210 350,200 Q300,190 250,200 Q200,190 150,200 Z"
            fill="rgba(219, 181, 134, 0.08)"
            stroke="rgba(219, 181, 134, 0.15)"
            strokeWidth="1"
          />
          
          {/* Connection paths for gift movement */}
          <path
            id="path1"
            className="connection-path"
            d="M200,180 Q300,100 450,170"
            fill="none"
            stroke="rgba(219, 181, 134, 0.2)"
            strokeWidth="2"
            strokeDasharray="5,5"
          />
          <path
            id="path2"
            className="connection-path"
            d="M180,200 Q250,120 380,190"
            fill="none"
            stroke="rgba(219, 181, 134, 0.2)"
            strokeWidth="2"
            strokeDasharray="5,5"
          />
          <path
            id="path3"
            className="connection-path"
            d="M220,190 Q350,130 520,180"
            fill="none"
            stroke="rgba(219, 181, 134, 0.2)"
            strokeWidth="2"
            strokeDasharray="5,5"
          />
          <path
            id="path4"
            className="connection-path"
            d="M250,170 Q400,90 600,160"
            fill="none"
            stroke="rgba(219, 181, 134, 0.2)"
            strokeWidth="2"
            strokeDasharray="5,5"
          />
        </svg>

        {/* Animated Gift Boxes moving along paths */}
        <div className="gift-box gift-box-1">
          <div className="gift-icon-small">🎁</div>
        </div>
        <div className="gift-box gift-box-2">
          <div className="gift-icon-small">🎁</div>
        </div>
        <div className="gift-box gift-box-3">
          <div className="gift-icon-small">🎁</div>
        </div>
        <div className="gift-box gift-box-4">
          <div className="gift-icon-small">🎁</div>
        </div>
      </div>

      {/* Feature Indicators positioned around the map */}
      <div className="feature-indicators">
        <div className="feature-item feature-reviews">
          <div className="feature-icon">
            <CiStar />
          </div>
          <div className="feature-label">Reviews</div>
          <div className="feature-pulse"></div>
        </div>

        <div className="feature-item feature-referrals">
          <div className="feature-icon">
            <CiShare2 />
          </div>
          <div className="feature-label">Referrals</div>
          <div className="feature-pulse"></div>
        </div>

        <div className="feature-item feature-leads">
          <div className="feature-icon">
            <CiUser />
          </div>
          <div className="feature-label">Leads</div>
          <div className="feature-pulse"></div>
        </div>

        <div className="feature-item feature-data">
          <div className="feature-icon">
            <CiDatabase />
          </div>
          <div className="feature-label">Data</div>
          <div className="feature-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default GlobalMapIllustration;
